import React from "react";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ProductsSection from "./components/ProductsSection";
import FeaturesSection from "./components/FeaturesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FreeContentSection from "./components/FreeContentSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FinalCTASection from "./components/FinalCTASection";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <FeaturesSection />
      <HowItWorksSection />
      <FreeContentSection />
      <TestimonialsSection />
      <FinalCTASection />
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
